import { render, staticRenderFns } from "./FirstBankView.vue?vue&type=template&id=54859f70&scoped=true"
import script from "./FirstBankView.vue?vue&type=script&lang=js"
export * from "./FirstBankView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54859f70",
  null
  
)

export default component.exports